import jQuery from 'jquery';
import Foundation from 'foundation-sites';
import FontFaceObserver from 'fontfaceobserver';
import 'magnific-popup';
import 'jquery-parallax.js';
import WOW from 'wow.js';

import log from './utils/logger';

($ => {
  initComponents();

	/**
   * Window load event listener
   */
  $(window).on('load', () => {
    $(window).resize();
    $( 'html, body' ).animate( { scrollTop: 0 }, 100 );

    $('.js-loading__inner').fadeOut('slow', function() {
      var timer = setInterval(function() {

        $('.js-loading').fadeOut(750, function() {
          clearInterval(timer);

          initFooter();
        });
      }, 100);

      // animate();
      // initRotatingText();
    });
  });

  /**
   * Initialize frontend components.
   */
  function initComponents() {
    initZF();
    initFonts();
    initHeader();
    initFooterCurtain();
    initMagnificPopup();
    initBanner();
    initCustomClick();
    animate();
    initBannerText();
    initRotatingText();
    credits();
  }

  /**
   * Foundation sites setup.
   */
  function initZF() {
    if($().foundation) {
      $(document).foundation();
    }
  }

  /**
   * Check if custom fonts are successfully loaded. Will detect if custom fonts are loaded.
   */
  function initFonts() {
    var ralewayFont = new FontFaceObserver('Raleway');

    $(document.body).addClass('font');

    ralewayFont.load(null, 10000 /* 10 seconds */).then(() => {
      $(document.body).addClass('font--raleway'); 
    });
  }


  /**
   * Homepage's banner text.
   */
    function initBannerText() {
        const duration = 100;
        const masks = $( '.js-banner__content__text .mask' );
        const totalMasks = masks.length;
        
        let counter = 0;

        const interval = setInterval( function() {
            let $mask = $( masks[ counter ] );
            var $maskContent = $mask.find( '.mask__content' );

            $maskContent.addClass( 'mask__content--transition' );
            $mask.prevAll( '.mask' ).first().find( '.mask__content').addClass( 'mask__content--transitioned' );

            counter++;

            if( totalMasks === counter ) {
                clearInterval( interval );

                const timeout = setTimeout( function() {
                    clearTimeout( timeout );
                    $maskContent.addClass( 'mask__content--transitioned' );
                }, duration );

                $( '.js-banner__button' ).addClass( 'banner__button--animated' );
                $( '.js-banner__content__text' ).addClass( 'animated' );
            }


        }, duration );
    }


  /**
   * Homepage's rotating text.
   */
  function initRotatingText() {
    var $rotatingText = $('.js-rotating-text');

    if($rotatingText.length == 0) return;

    $rotatingText.addClass('js-rotating-text--initialized');

    var $container = $rotatingText.find('h1');
    var index = 0;
    var initialInterval = 900;
    var interval = initialInterval;
    var text = $container.html();
    text = text.split(' ');

    rotateText();

    /**
     * Rotate text.
     */
    function rotateText() {
      if(index == text.length) index = 0;
      
      $container.html(text[index].trim());

      if(index == 0) interval = initialInterval * 2;
      else interval = initialInterval;
      
      index++;

      setTimeout(rotateText, interval);
    }
  }
  
  /**
   * Initialize header features.
   */
  function initHeader() {
    var $hamburger = $('.js-hamburger');
    var $navigation = $('#navigation-wrapper');

    if($hamburger.length && $navigation.length) {
      $hamburger.hover(() => { /* In */
        $navigation.removeClass('mouseout');
        $navigation.addClass('mousein');
      }, () => { /* Out */
        $navigation.removeClass('mousein');
        $navigation.addClass('mouseout');
      });
    }
    
    if($('.js-offset').length == 0) return;

    var $header = $('#container > header');
    var offset = $('.js-offset').position().top;
    var scrollTopPos = $(window).scrollTop() + getHeaderHeight();
    var isAlt = false;

    toggleHeaderAlt();

    $(window).scroll(function() {
      scrollTopPos = $(this).scrollTop() + getHeaderHeight(); 

      toggleHeaderAlt();
    });

    /**
     * Toggle between headers.
     */
    function toggleHeaderAlt() {
      if(scrollTopPos >= offset && !isAlt) {
        $header.addClass('alt');   
        isAlt = true;
      } else if(scrollTopPos < offset && isAlt) {
        $header.removeClass('alt');
        isAlt = false;
      }
    }
  }


  /**
   * The footer curtain for parallax effect.
   */
  function initFooterCurtain() {
    var $footerCurtain = $('#footer-curtain');

    $footerCurtain.css({
      'height': getFooterHeight()
    });
  }

  /**
   * Footer
   */
  function initFooter() {
    var $footer = $('#container > footer');

    $footer.css({
      'display': 'block',
      'visibility': 'visible'
    });
  }
  
  /**
   * Apply section radius based on the of the element.
   */
  function initSectionLeaf() {
    var $leafs = $('.js-section--leaf');

    if($leafs.length) {
      $leafs.each((i, e) => {
        var $leaf = $(e);
        var height = $leaf.innerHeight() + 'px';
        
        $leaf.css('borderTopLeftRadius', height);
        $leaf.css('borderBottomRightRadius', height);
      });
    }
  }
  
  var resizeTimer;

  $(window).resize(() => {
    initFooterCurtain();
    initSectionLeaf();
    initCover();
    initFullscreen();

    var $navigation = $('#navigation-wrapper');

    clearTimeout(resizeTimer);
    $navigation.addClass('resizing');

    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      $navigation.removeClass('resizing');  
    }, 250); 
  });

  /**
   * Magnific popup.
   */
  function initMagnificPopup() {
    if($().magnificPopup) {
      $('.js-video').magnificPopup({
        type: 'iframe',
        markup: '<div class="mfp-iframe-scaler">'+
          '<div class="mfp-close"></div>'+
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
        '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button 
        patterns: {
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          } 
        },
        gallery: {
          enabled: true
        },
        removalDelay: 300,
        mainClass: 'mfp-fade'
      });
    }
  }

  /**
   * Parallax banner.
   */
  function initBanner() {
    if($().parallax) {
      var $banner = $('.js-banner');

      if($banner.length) {
        $banner.addClass('js-parallax-ready');
        $banner.parallax();
      }

    }
  }

  /**
   * Animation using WOW.js
   */
  function animate() {
    // TODO: WOW setup.
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
      }
    );
    wow.init();
  }

  /**

  /**
   * Full height container minus the height of the header and footer.
   */
  function initCover() {
    var height = $(window).height() - (getHeaderHeight() + getFooterHeight()) + 'px';

    $('.js-cover').css('height', height);
  }

  /**
   * Set the .js-cover to the height of the current window minus the header height.
   */
  function initFullscreen() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    document.documentElement.style.setProperty('--window-height', getWindowHeight() + 'px');
    $('.js-fullscreen').css('min-height', getWindowHeight() + 'px');
  }

  /**
   * Custom click function
   */
  function initCustomClick() {
    $('.js-click').click(function() {
      location.href = $(this).attr('data-href');
    });
  }

  /**
   * Get the height of the header.
   *
   * @return {int} The height of the header in pixels.
   */
  function getHeaderHeight() {
    return $('#container > header').innerHeight();
  }

  /**
   * Get the height of the footer.
   *
   * @return (int} The height of the footer.
   */
  function getFooterHeight() {
    return $('#container > footer').innerHeight();
  }

  /**
   * Get the heigth of the window.
   *
   * @return {int} The height of the document's window in pixels.
   */
  function getWindowHeight() {
    return $(window).innerHeight();
  }

   /**
   * Log information to the console.
   */
  function credits() {
    const siteName = $(document.body).attr('data-site-name');
    const siteDescription = $(document.body).attr('data-site-description');
    const year = (new Date()).getFullYear();
    const copyright = `Copyright © ${year} ${siteName}. All rights reserved.`;
    const designer = 'Designed by: Natalie Cheng http://natcheng.com';
    const developer = 'Developed by: Nordanne Isahac https://www.denisahac.xyz';
    
    console.log(`%c${siteName}`, 'font-family: Arial; font-size: 40px; font-weight: 700; text-transform: uppercase;');
    log(siteDescription);
    log(copyright);
    log('');
    log(designer);
    log(developer);
  } 
})(jQuery);


